import { useCallback, useEffect, useMemo, useState } from "react";
import { useWindowSize } from "../../hooks/useWindowSize";
import { Route, Routes, useNavigate } from "react-router";
import { LoadingSpinner } from "../../components/LoadingSpinner";
import { ProfileHeader } from "../../components/ProfileHeader";
import { ProfileBar } from "../../components/ProfileBar";
import { CompaniesPage } from "./companies";
import CameraList from "../../components/CameraList";
import { ProfilePage } from ".";
import { UsersPage } from "./users";
import { PermissionsPage } from "./permissions";
import { GroupsPage } from "./groups";
import { LocationsPage } from "./locations";
import { ProductsPage } from "./products";
import { MachinesPage } from "./machines";
import { DevPage } from "./dev";
import API from "../../service/api";
import { CustomModal } from "../../components/CustomModal";

export const ProfileLayout = ({userData, onUserUpdate}) => {
    const { innerWidth } = useWindowSize();
    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);

    const mobile = useMemo(() => innerWidth < 1000, [innerWidth]);

    const fetch = useCallback(async () => {
        try {
            setProfile(await API.GET('/api/users/adm'));
        }catch(err){
            alert(`Cannot access administration page: ${err.message}`);
            navigate('/');
        }
    }, []);

    useEffect(() => {
        fetch();
    }, []);

    if (!profile) return <LoadingSpinner/>

    return (
        <div className="d-flex flex-fill flex-row h-100 w-100 overflow-hidden" style={{background: '#eee'}}>
            <div className="d-flex h-100">
                <ProfileBar profile={profile} mobile={mobile}/>
            </div>
            <div className={"d-flex flex-fill overflow-auto"} style={{marginTop: mobile ? 40 : 0}}>
                <Routes>
                    <Route path="" element={
                        <ProfilePage
                            profile={profile}
                            canUpdateCompany={profile.permissions?.CompanyEdit}
                            onUserUpdate={onUserUpdate}
                        />
                    }/>
                    { profile.permissions?.SubcompanyView &&
                        <Route path="companies" element={
                            <CompaniesPage
                                myCompany={profile.company}
                                canAdd={profile.permissions?.SubcompanyAdd}
                                canAddUser={profile.permissions?.SubcompanyAddUser}
                                canDeleteSubcompany={profile.permissions?.SubcompanyDelete}
                                canEditSubcompany={profile.permissions?.SubcompanyEdit}
                                canViewUsers={profile.permissions?.SubcompanyUsers}
                                onUserUpdate={onUserUpdate}
                            />
                        }/>
                    }
                    { profile.permissions?.UserView &&
                        <Route path="users" element={
                            <UsersPage
                                userData={userData}
                                canAddUser={profile.permissions?.UserAdd}
                                canDeleteUser={profile.permissions?.UserDelete}
                                canEditPermissions={profile.permissions?.UserEdit}
                                onUserUpdate={onUserUpdate}
                            />
                        }/>
                    }
                    { profile.permissions?.RightsView &&
                        <Route path="permissions" element={
                            <PermissionsPage
                                myRightsId={userData.rightsId}
                                canAdd={profile.permissions?.RightsAdd}
                                canEdit={profile.permissions?.RightsEdit}
                                canDelete={profile.permissions?.RightsDelete}
                            />
                        }/>
                    }
                    { profile.permissions?.GroupView &&
                        <Route path="groups" element={
                            <GroupsPage
                                canAdd={profile.permissions?.GroupAdd}
                                canDelete={profile.permissions?.GroupDelete}
                                canEdit={profile.permissions?.GroupEdit}
                            />
                        }/>
                    }
                    { profile.permissions?.LocationView &&
                        <Route path="locations" element={
                            <LocationsPage
                                userData={userData}
                                canAdd={profile.permissions?.LocationAdd}
                                canDelete={profile.permissions?.LocationDelete}
                                canEdit={profile.permissions?.LocationEdit}
                                canAssignMachines={profile.permissions?.LocationAssignMachines}
                                canViewMachines={profile.permissions?.MachineView}
                            />}
                        />
                    }
                    { profile.permissions?.ProductView &&
                        <Route path="products" element={
                            <ProductsPage
                                canAdd={profile.permissions?.ProductAdd}
                                canDelete={profile.permissions?.ProductDelete}
                                canEdit={profile.permissions?.ProductEdit}
                            />
                        }/>
                    }
                    { profile.permissions?.MachineView &&
                        <Route path="machines" element={
                            <MachinesPage
                                canEdit={profile.permissions?.MachineEdit}
                                canAssignToLocation={profile.permissions?.LocationAssignMachines}
                                canTransfer={profile.permissions?.MachineTransfer}
                                canActivate={profile.permissions?.MachineActivate}
                            />
                        }/>
                    }
                    {/* { profile.permissions?.Dev &&
                        <Route path="dev" element={
                            <DevPage/>
                        }/>
                    } */}
                    <Route path="k" element={<CameraList/>} />
                </Routes>
            </div>
        </div>
    )
}